import React from 'react';
import { dummyClick, emptyFunction } from '../utilities';
import { YellowButton, BlueLink } from '../buttons';

const styles = (posX, posY) => Object.assign({ zIndex: 9999, top: (posY * 100 + '%')}, modalWidth(posX));
const modalWidth = (posX) => (
  window.innerWidth > 640
    ? posX > 0.5 ? {right: (100 - posX * 100 + '%')} : {left: (posX * 100 + '%')}
    : {left: 0, right: 0, width: 'initial'}
);

const PoppinForm = ({body, posX, posY, t:{placeholder, okBtn, cancelBtn}, modalOnClick, onChange, onKeyUp, okOnClick, cancelOnClick}) => (
  <div className="a-pop-pin-modal absolute" style={styles(posX, posY)} onClick={modalOnClick}>
    <img src="/images/webreader/poppin.svg" className="block" width="34" height="34" />
    <input id="poppinFormBodyInput" type="text" name="pop-pin-body" className="a-pop-pin-body" autoFocus
           value={body}
           placeholder={placeholder}
           onChange={onChange}
           onKeyUp={onKeyUp}
    />
    <YellowButton text={okBtn} className={'a-pop-pin-submit white grow'} onClick={okOnClick} />
    <BlueLink text={cancelBtn} className={'a-pop-pin-dismiss white t-pt1'} onClick={cancelOnClick} />
  </div>
);

PoppinForm.defaultProps = {
  body: '',
  posX: null,
  posY: null,
  t: {
    placeholder: 'EN placeholder...',
    okBtn: 'EN okBtn',
    cancelBtn: 'EN cancelBtn',
  },
  modalOnClick: dummyClick,
  onChange: emptyFunction,
  onKeyUp: emptyFunction,
  okOnClick: dummyClick,
  cancelOnClick: dummyClick
};

export {PoppinForm};